import { Tabs, TabsList, TabsTrigger } from "@/components/ui/baseUi/tabs"
import { cn } from "@/modules/lib/utils"
import { useBoxLead } from "@modules/boxLead/hooks/useBoxLeadDetails"
import { word } from "@modules/core/utils/i18n"
import { useSidebar } from "@modules/sidebar/hooks/useSidebar"
import { startTransition } from "react"

type BoxLeadTabProps = {
  leadId: string
  activeIndex: string
  className?: string
} & React.ComponentProps<"div">

export function BoxLeadTab({ leadId, activeIndex, className, ...props }: BoxLeadTabProps) {
  const { data: leadDetails } = useBoxLead(leadId)
  const { setCurrentStackState } = useSidebar()

  const selectTab = (index: string) => {
    startTransition(() => {
      setCurrentStackState("activeTabIndex", index)
    })
  }

  return (
    <Tabs defaultValue={activeIndex}>
      <TabsList variant="default" className={cn(className)} {...props}>
        <TabsTrigger variant="default" onClick={() => selectTab("0")} value="0">
          {word("box.lead.detailsInfo.tab.overview")}
        </TabsTrigger>
        {leadDetails.user?.id ? (
          <TabsTrigger variant="default" onClick={() => selectTab("1")} value="1">
            {word("box.member.detailsInfo.profile")}
          </TabsTrigger>
        ) : null}
        {leadDetails.user?.id ? (
          <TabsTrigger variant="default" onClick={() => selectTab("2")} value="2">
            {word("box.member.detailsInfo.offers")}
          </TabsTrigger>
        ) : null}
      </TabsList>
    </Tabs>
  )
}
